import { call, takeLatest } from '@redux-saga/core/effects'
import { put, select } from 'redux-saga/effects'
import { getSelectedItem } from '../selectors'
import { IItem } from '../store/timeline.types'
import { TimelineConstants } from '../store/timeline.constants'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../user/selectors'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { setDrainState } from '../../procedures/drain/store/drain.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* setDrainProcedureItem() {
  const selectedItem: IItem = yield select(getSelectedItem)
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  if (!pcrID) {
    return
  }
  try {
    if (selectedItem) {
      const pcrDocsService = new PcrDocsService(serviceId)
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      const drainState = pcrDoc.patient.drainStateList?.find((drainState) => {
        if (selectedItem.labelHeader) {
          drainState.time = selectedItem?.labelHeader
        }
        return drainState.key === selectedItem.key
      })
      yield put(setDrainState(drainState))
    }
  } catch (e) {
    yield put(throwPcrException(`setDrainProcedureItem() error: ${e}`))
  }
}

export function* setDrainProcedureItemSaga() {
  yield takeLatest([TimelineConstants.SET_DRAIN_PROCEDURE_ITEM], performWithMutexHOG, setDrainProcedureItem)
}
